
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/edit-2","xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#8d98aa","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M12.155 3.3l-7.526 7.966a2.8 2.8 0 00-.614 1.315l-.339 2.97a1.4 1.4 0 001.714 1.623l2.952-.5a2.632 2.632 0 001.274-.693l7.526-7.966c1.3-1.375 1.888-2.942-.138-4.858-2.016-1.901-3.547-1.232-4.849.143z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M10.899 4.629a5.616 5.616 0 005 4.721M2.75 20.167h16.5","opacity":".4"}})])])
          )
        }
      }
    